import React from 'react'
import ReactMarkdown from 'react-markdown'

import { AcornsIcon } from '@acorns/icons'
import styled from 'styled-components'

const CTAWrapper = styled.div`
  align-items: center;
  display: flex;
  margin: -36px 0 40px;

  img {
    width: 16px;
    height: 10px;
    margin-left: 6px;
  }
`

export const HeadingRenderer = (props) => {
  const Heading = ReactMarkdown.renderers.heading
  if (props.level === 4) {
    return (
      <CTAWrapper>
        <Heading {...props} />
        <AcornsIcon icon={AcornsIcon.Icon.RightArrowGreen} width="24px" />
      </CTAWrapper>
    )
  }

  return <Heading {...props} />
}
